import { createSlice } from "@reduxjs/toolkit";
import { FoodState } from "../types/state";
import { LOADING } from "../../../types";
import { addFood } from "../actions/add";
import { deleteFood } from "../actions/delete";
import { toggleFoodVisibility } from "../actions/toggleVisibility";
import { setFoodError } from "../actions/setError";
import { setFoodData } from "../actions/setData";

const initialState: FoodState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const foodSlice = createSlice({
  name: "food",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setFoodError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setFoodData, (state, { payload: foods }) => {
        state.data = foods;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addFood.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addFood.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addFood.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteFood.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteFood.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteFood.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleFoodVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(toggleFoodVisibility.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(toggleFoodVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
